import React from 'react';
import DateFilterDropdownItem from './_DateFilterDropdownItem';

function DateFilterDropdown({search, isYear, settings, dateSpan}) {
    const s = settings;

    let monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December' ];    
    
    let years = Array(6).fill(new Date().getFullYear());

    if (dateSpan)
    {
        years = Array(dateSpan+1).fill(new Date().getFullYear());
    }
        
    let dropdown;
    let clsName = 'filter filter__dropdown filter__small';
    if(s.appId == 'ourstories'){
        clsName = 'filter filter__dropdown';
    }

    
    if (isYear)
    {
        dropdown = <DateFilterDropdownItem search={search} title='Date' options={years.map((key, index) => key - index)} />;
    }else
    {
        dropdown = <DateFilterDropdownItem search={search} title={translate('Month', s)} options={monthNames} />;
    }    
	return (
        <div className={clsName}>
            {dropdown}
        </div>
	);
}

export default DateFilterDropdown;